export default "__VITE_ASSET__6jX0UN4C__"